import { hydrateTableStripes } from './table'
import { hydrateMenuStripes } from './menu'
import { hydrateInfographicStripes } from './infographic'
import { hydrateHeaderVideoStripes } from './headerVideo'
import { hydrateGoogleMapStripes } from './googleMap'
import { hydrateGalleryStripes } from './gallery'

interface HydrateEventDetail {
  container?: Element
}

declare global {
  interface WindowEventMap {
    'hydrate-vessel-stripes': CustomEvent<HydrateEventDetail>
  }
  interface DocumentEventMap {
    'hydrate-vessel-stripes': CustomEvent<HydrateEventDetail>
  }
  interface Window {
    hydrateVesselStripes: (container?: Document | Element) => void
  }
}

/**
 * Hydrates all Vessel stripe components within a given container.
 * Call this function after dynamically loading new content to initialize interactivity.
 *
 * @param container - The container element to hydrate (defaults to document)
 */
export function hydrateVesselStripes(
  container: Document | Element = document
): void {
  hydrateTableStripes(container)
  hydrateMenuStripes(container)
  hydrateInfographicStripes(container)
  hydrateHeaderVideoStripes(container)
  hydrateGoogleMapStripes(container)
  hydrateGalleryStripes(container)
}

// Expose globally for backward compatibility and external usage
window.hydrateVesselStripes = hydrateVesselStripes

// Auto-hydrate on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => hydrateVesselStripes())
} else {
  hydrateVesselStripes()
}

// Listen for custom hydration events
document.addEventListener(
  'hydrate-vessel-stripes',
  (event: CustomEvent<HydrateEventDetail>) => {
    hydrateVesselStripes(event.detail?.container || document)
  }
)

// Export individual hydration functions for advanced usage
export {
  hydrateTableStripes,
  hydrateMenuStripes,
  hydrateInfographicStripes,
  hydrateHeaderVideoStripes,
  hydrateGoogleMapStripes,
  hydrateGalleryStripes
}
